import React, { useEffect } from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { company } from "../mock/mock";
import QuoteForm from "../components/QuoteForm";

const Contact = () => {
  useEffect(() => window.scrollTo(0, 0), []);

  const infos = [
    { icon: Phone, label: "Téléphone", value: company.phone, href: `tel:${company.phone.replace(/\s/g, "")}` },
    { icon: Mail, label: "Email", value: company.email, href: `mailto:${company.email}` },
    { icon: MapPin, label: "Zone d'intervention", value: company.address, href: null },
    { icon: Clock, label: "Disponibilité", value: "7j/7 • Week-ends & jours fériés", href: null },
  ];

  return (
    <div className="pt-20">
      {/* HERO */}
      <section className="bg-[#1B2A4A] py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center animate-fadeUp">
          <span className="inline-block bg-[#C9A227] text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-5 uppercase tracking-wider">Contact</span>
          <h1 className="text-3xl sm:text-5xl font-extrabold text-white leading-tight">Demandez votre devis gratuit</h1>
          <p className="mt-5 text-lg text-gray-300 max-w-2xl mx-auto">
            Remplissez le formulaire ci-dessous et nous vous contacterons dans les plus brefs délais pour établir un devis personnalisé.
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-5 gap-10">
          {/* Info column */}
          <div className="lg:col-span-2">
            <h2 className="text-2xl font-bold text-[#1B2A4A] mb-6">Nos coordonnées</h2>
            <div className="space-y-4">
              {infos.map((info, i) => {
                const Icon = info.icon;
                const content = (
                  <div className="flex items-start gap-4 bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                    <div className="w-12 h-12 rounded-lg bg-[#1B2A4A]/5 flex items-center justify-center shrink-0">
                      <Icon size={22} className="text-[#C9A227]" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">{info.label}</p>
                      <p className="font-semibold text-[#1B2A4A] break-all">{info.value}</p>
                    </div>
                  </div>
                );
                return info.href ? (
                  <a key={i} href={info.href} className="block">{content}</a>
                ) : (
                  <div key={i}>{content}</div>
                );
              })}
            </div>

            <div className="mt-6 rounded-xl overflow-hidden border border-gray-100 shadow-sm">
              <iframe
                title="Carte DMP Déménagement"
                src="https://www.google.com/maps?q=Montreuil,France&output=embed"
                width="100%"
                height="250"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          {/* Form column */}
          <div className="lg:col-span-3">
            <QuoteForm />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
